<template>
    <el-card class="sirket-list" body-style="padding: 0px">
        <template slot="header">
            <el-row type="flex" justify="space-between">
                <h4>Fatura Bilgisi Listesi</h4>
                <el-button icon="el-icon-plus" size="medium" @click="add">Fatura Bilgisi Ekle</el-button>
            </el-row>
        </template>

        <el-input v-model="search" placeholder="Fatura bilgisi ara..." clearable>
            <i class="el-icon-search" slot="prepend"/>
        </el-input>

        <el-table
                v-loading="loading"
                :data="paginated"
                empty-text="Henuz Fatura Bilgisi eklenmedi!">

            <el-table-column type="expand">
                <template slot-scope="{ row }">
                  <el-row type="flex" justify="space-between">
                      <div>
                          <p><b>Şirket Tel:</b> {{row.tel}}</p>
                          <p><b>Şehir:</b> {{row.sehir}}</p>
                          <p><b>ilce:</b> {{row.ilce}}</p>
                          <p><b>Posta Kodu:</b> {{row.posta_kodu}}</p>
                          <p v-if="row.pasif_notu"><b>Pasif Notu:</b> {{row.pasif_notu}}</p>
                      </div>
                      <div v-if="row.latitude && row.longitude">
                          <p><b>Konum</b></p>
                          <mak-map
                                  view-only
                                  mini-map
                                  :lat="row.latitude"
                                  :lng="row.longitude"/>
                      </div>
                  </el-row>
                </template>
            </el-table-column>

            <el-table-column prop="adi" label="Şirket Adı">
                <template slot="header" slot-scope="{}">Şirket Adı({{count}})</template>
            </el-table-column>
            <el-table-column prop="cep" label="Cep Tel"></el-table-column>
            <el-table-column prop="sirket_yetkili" label="Şirket Yetkili Adi"></el-table-column>

            <el-table-column label="Konum" width="70">
                <template slot-scope="{ row }">
                    <i
                            v-if="row.latitude && row.longitude"
                            class="el-icon-location"
                            title="Konum bilgisi var"
                            style="color: #13ce66"/>
                    <i
                            v-else
                            class="el-icon-delete-location"
                            title="Konum bilgisi yok"/>
                </template>
            </el-table-column>
            <el-table-column label="Aktif mi?" width="85">
                <template slot-scope="{ row }">
                    <el-tag v-if="row.aktif === '1'" type="success">
                        <i class="el-icon-video-play"/>Aktif
                    </el-tag>
                    <el-tag v-else type="warning">
                        <i class="el-icon-video-pause"/>Pasif
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column width="75">
                <mak-more slot-scope="{ row }">
                    <el-button
                            v-if="row.aktif === '0'"
                            class="w-100"
                            icon="el-icon-video-play"
                            type="success"
                            @click="aktifEt(row.id)">Aktif Et</el-button>
                    <el-button
                            v-else
                            class="w-100"
                            icon="el-icon-video-pause"
                            @click="openPasifModal(row)">Pasif Et</el-button>
                    <br>
                    <el-button
                            class="w-100"
                            icon="el-icon-edit"
                            title="Güncelle"
                            @click="update(row)">Güncelle</el-button>

                    <el-popconfirm
                            title="Silmek istediginize emin misiniz?"
                            confirmButtonText="Evet"
                            cancelButtonText="iptal"
                            @onConfirm="remove(row)"
                    >
                        <el-button
                                slot="reference"
                                class="w-100"
                                icon="el-icon-delete"
                                title="Sil"
                                type="danger">Sil</el-button>
                    </el-popconfirm>
                </mak-more>
            </el-table-column>
        </el-table>

        <br>
        <el-pagination
                background
                layout="total, prev, pager, next, sizes"
                :current-page.sync="pagination.currentPage"
                :page-sizes="[10, 25, 50, 100]"
                :page-size.sync="pagination.pageSize"
                :total="filtered.length">
        </el-pagination>
        <br>

        <el-dialog
                width="90%"
                :title="`Fatura Bilgisi ${ sirket ? 'Güncelle' : 'Ekle'}`"
                :visible.sync="visible">
            <sirket-form v-if="visible" :sirket="sirket" :visible="visible" @success="sirketAdded"/>
        </el-dialog>

        <el-dialog
                width="91%"
                :title="`${ pasif.adi } adlı Fatura Bilgisini Pasif Et`"
                :visible.sync="pasif.modal">
            <el-row>
                <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        placeholder="Pasif edebilmek için not girin!"
                        v-model="pasif.notu"/>
            </el-row>
            <br><br>
            <el-row>
                <el-button
                        type="warning"
                        icon="el-icon-video-pause"
                        :disabled="!pasif.notu"
                        @click="pasifEt">
                    Pasif et
                </el-button>
            </el-row>
        </el-dialog>
    </el-card>
</template>

<script>
    import SirketForm from './SirketForm.vue'
    import MakMap from '@/components/MakMap.vue'

    export default {
        name: 'sirket-list',
        components: { MakMap, SirketForm },
        data() {
            return {
                visible: false,
                loading: false,
                list: [],
                sirket: null,
                pasif: {
                    notu: null,
                    modal: false,
                    id: null,
                    adi: null,
                },
                search: null,
                pagination: {
                    pageSize: 25,
                    currentPage: 1,
                },
            };
        },
        computed: {
            filtered() {
                if (this.search) {
                    return this.list.filter((a) => a.adi.toLowerCase().includes(this.search.toLowerCase()));
                }
                return this.list;
            },
            count() {
                return this.filtered.length;
            },
            paginated() {
                const { pageSize, currentPage } = this.pagination;
                return this.filtered.slice(pageSize * (currentPage - 1), pageSize * currentPage);
            }
        },
        methods: {
            add() {
                this.sirket = null;
                this.visible = true;
            },
            update(sirket) {
                this.sirket = Object.assign({}, sirket);
                this.visible = true;
            },
            remove(sirket) {
                this.loading = true;
                this.$requests.Sirket.deleteSirket(sirket.id)
                    .then(() => {
                        console.debug('removed successfully', sirket.id);
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    })
            },
            sirketAdded() {
                this.visible = false;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.$requests.Sirket.getSirket()
                    .then((data) => {
                        this.list = data;
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            aktifEt(id) {
                this.loading = true;
                this.$requests.Sirket.sirketAktifEt(id)
                    .then(() => {
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error toggling sirket aktif', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
            openPasifModal(sirket) {
                this.pasif.id = sirket.id;
                this.pasif.adi = sirket.adi;
                this.pasif.notu = null;
                this.pasif.modal = true;
            },
            pasifEt() {
                this.loading = true;
                this.$requests.Sirket.sirketPasifEt(this.pasif.id, this.pasif.notu)
                    .then(() => {
                        this.pasif = {
                            modal: false,
                            notu: null,
                            id: null,
                            adi: null,
                        };
                        this.fetch();
                    })
                    .catch((e) => {
                        console.error('error toggling sirket aktif', e);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.fetch();
        },
    }
</script>

<style lang="scss" scoped>
    .sirket-list {
        ::v-deep .el-card__header {
            h4 {
                font-size: 1.4em;
            }
            .el-button {
                font-size: 1.2em;
            }
        }
    }
</style>
